import { TERMINAL_ALGO_STATUSES } from '@/service/ws/account-order-merge'
import { AlgoState, AlgoType, ScaleLevelStatus } from '@/types/generated/algo'
import { OrderSide } from '@/types/generated/common/trading'

export interface ScaleChartLevel {
  key: string
  accountId: string
  side: OrderSide
  index: number
  price: string
  quantity: string
}

/**
 * The resting levels of the account's running Scales on `symbol`. public-api strips a
 * Scale's child orders from the order stream, so the algo state is the only place the
 * chart can find them.
 */
export function workingScaleLevels(
  states: readonly AlgoState[],
  accountId: string | undefined,
  symbol: string
): ScaleChartLevel[] {
  const out: ScaleChartLevel[] = []
  for (const state of states) {
    const params = state.algoData?.scale?.params
    if (
      state.algoType !== AlgoType.ALGO_TYPE_SCALE ||
      TERMINAL_ALGO_STATUSES.has(state.status) ||
      !params ||
      params.accountId !== accountId ||
      params.symbol !== symbol
    ) {
      continue
    }
    for (const level of state.algoData?.scale?.levels ?? []) {
      if (level.status !== ScaleLevelStatus.SCALE_LEVEL_STATUS_WORKING) continue
      out.push({
        key: `${state.id}:${level.index}`,
        accountId: params.accountId,
        side: params.orderSide,
        index: level.index,
        price: level.price,
        quantity: level.quantity,
      })
    }
  }
  return out
}
